// extracted by mini-css-extract-plugin
export var closeButton = "_47-3";
export var header = "_47-0";
export var link = "_47-1";
export var retryButton = "_47-2";